import { DASHBOARD_HOME_ROUTE, PLAN_ROUTE, CURRENT_ROUTE } from './postLoginRoutes'

export const dashboardLayoutRoutes = [
  DASHBOARD_HOME_ROUTE,
  PLAN_ROUTE,
  CURRENT_ROUTE,
]
